<template>
  <v-layout row wrap class="w-100">
    <v-flex xs12 sm6 md4 lg2>
      <SelectCreditors
        :selected="localCreditors"
        :active="true"
        @selectedCreditors="onCreditorsChange($event)"
        @creditorsList="onCreditorsList"
      ></SelectCreditors>
    </v-flex>
    <v-flex xs12 sm6 md4 lg2>
      <v-select
        v-model="localPublics"
        @change="emitChange()"
        success
        clearable
        :items="publicOptions"
        multiple
        :selected="localPublics == 0 ? undefined : localPublics"
        label="Público"
        flat
        item-text="name"
        item-value="value"
        box
        class="text-details-none"
      >
        <template v-slot:selection="{ item, index }">
          <span v-if="index === 0" style="padding-right: 5px">{{
            item.name
          }}</span>
          <span v-if="index === 1" class="grey--text caption"
            >(+{{
              localPublics.length -
              1 +
              (localPublics.length == 2 ? " outro" : " outros")
            }})</span
          >
        </template>
      </v-select>
    </v-flex>
    <v-flex xs12 sm6 md4 lg2>
      <v-select
        box
        flat
        success
        @change="emitChange()"
        multiple
        clearable
        class="text-details-none"
        label="Tipo de abordagem"
        :items="approachOptions"
        v-model="localApproachTypes"
      >
        <template v-slot:selection="{ item, index }">
          <span v-if="index === 0" style="padding-right: 5px">{{ item }}</span>
          <span
            v-if="index === 1"
            style="padding-left: 5px"
            class="grey--text caption"
            >(+{{
              localApproachTypes.length -
              1 +
              (localApproachTypes.length == 2 ? " outro" : " outros")
            }})</span
          >
        </template>
      </v-select>
    </v-flex>
    <v-flex xs12 sm6 md4 lg2>
      <v-select
        box
        flat
        success
        multiple
        clearable
        hide-details
        item-text="name"
        item-value="value"
        :items="firingOptions"
        @change="emitChange()"
        label="Tipo de disparo"
        v-model="localFiringType"
      >
        <template v-slot:selection="{ item, index }">
          <span v-if="index === 0" style="padding-right: 5px">{{
            item.name
          }}</span>
          <span
            v-if="index === 1"
            style="padding-left: 5px"
            class="grey--text caption"
            >(+{{
              localFiringType.length -
              1 +
              (localFiringType.length == 2 ? " outro" : " outros")
            }})</span
          >
        </template>
      </v-select>
    </v-flex>
    <v-flex xs12 sm6 md4 lg2>
      <v-select
        box
        flat
        success
        multiple
        clearable
        hide-details
        label="Gateway"
        item-value="id"
        item-text="name"
        :items="gatewayOptions"
        @change="emitChange()"
        v-model="localGateway"
      >
        <template v-slot:selection="{ item, index }">
          <span v-if="index === 0" style="padding-right: 5px">{{
            item.name
          }}</span>
          <span
            v-if="index === 1"
            style="padding-left: 5px"
            class="grey--text caption"
            >(+{{
              localGateway.length -
              1 +
              (localGateway.length == 2 ? " outro" : " outros")
            }})</span
          >
        </template>
      </v-select>
    </v-flex>
    <v-flex xs12 sm6 md4 lg2>
      <v-md-date-range-picker
        style="margin: 0px !important"
        :opens="'right'"
        @change="onDateChange"
        :presets="datePresets"
        :start-date="localRange.start"
        :end-date="localRange.end"
      ></v-md-date-range-picker>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";
import gatewaysService from "@/services/gateways";
import strategyPublic from "@/utils/strategy-public";
import SelectCreditors from "@/components/creditor/SelectCreditors";

const APPROACH_TYPES = [
  "SMS",
  "EMAIL",
  "PUSH",
  "CALL_CELLPHONE",
  "CALL_PHONE",
  "URA_SANITIZATION",
  "ORGANIC",
  "WHATSAPP",
];

const FIRING_TYPES = [
  { name: "Automático", value: "AUTO" },
  { name: "Manual", value: "MANUAL" },
  { name: "Incentivo", value: "INCENTIVE" },
];

export default {
  components: {
    SelectCreditors,
  },
  props: {
    initialCreditors: {
      type: Array,
      default() {
        return [];
      },
    },
    initialPublics: {
      type: Array,
      default() {
        return [];
      },
    },
    initialApproachTypes: {
      type: Array,
      default() {
        return [];
      },
    },
    initialFiringType: {
      type: Array,
      default() {
        return [];
      },
    },
    initialGateway: {
      type: Array,
      default() {
        return [];
      },
    },
    initialRange: {
      type: Object,
      default() {
        return {
          start: moment().format("YYYY-MM-DD"),
          end: moment().format("YYYY-MM-DD"),
        };
      },
    },
  },
  data() {
    return {
      localCreditors: [...this.initialCreditors],
      localPublics: [...this.initialPublics],
      localApproachTypes: [...this.initialApproachTypes],
      localFiringType: [...this.initialFiringType],
      localGateway: [...this.initialGateway],
      localRange: { ...this.initialRange },
      creditorsIds: [],
      gatewayOptions: [],
      publicOptions: strategyPublic.strategyPublic,
      approachOptions: APPROACH_TYPES,
      firingOptions: FIRING_TYPES,
      datePresets: [
        { label: "Hoje", range: this.getRange(0, 0) },
        { label: "Ontem", range: this.getRange(1, 1) },
        { label: "Últimos 7 dias", range: this.getRange(6, 0) },
        { label: "Últimos 30 dias", range: this.getRange(29, 0) },
        { label: "Este mês", range: this.getRange(0, 0, "month") },
        { label: "Mês passado", range: this.getRange(1, 1, "month") },
      ],
    };
  },
  watch: {
    initialCreditors(val) {
      this.localCreditors = [...val];
    },
    initialPublics(val) {
      this.localPublics = [...val];
    },
    initialApproachTypes(val) {
      this.localApproachTypes = [...val];
    },
    initialFiringType(val) {
      this.localFiringType = [...val];
    },
    initialGateway(val) {
      this.localGateway = [...val];
    },
    initialRange(val) {
      this.localRange = { ...val };
    },
  },
  computed: {
    filterPayload() {
      return {
        creditors: this.localCreditors,
        publics: this.localPublics,
        approachTypes: this.localApproachTypes,
        firingType: this.localFiringType,
        gateway: this.localGateway,
        range: { ...this.localRange },
        creditorsIds: this.creditorsIds,
      };
    },
  },
  async created() {
    await this.fetchGateways();
    this.$emit("gateways-loaded", this.gatewayOptions);
  },
  methods: {
    async fetchGateways() {
      await gatewaysService.gateways().then((resp) => {
        resp.objects.forEach((item) => {
          this.gatewayOptions.push({
            id: item.id,
            name: item.name,
          });
        });
      });
    },
    getRange(startOffset = 0, endOffset = 0, period = "day") {
      return [
        moment().subtract(startOffset, period).startOf(period),
        moment().subtract(endOffset, period).endOf(period),
      ];
    },
    onCreditorsChange(event) {
      this.localCreditors = event;
      this.emitChange();
    },
    onCreditorsList(newCreditors) {
      this.creditorsIds = newCreditors.map((obj) => obj.creditor_id);
      this.$emit("creditors-list", this.creditorsIds);
    },
    onDateChange(values) {
      this.localRange.start = moment(values[0]._d).format("YYYY-MM-DD");
      this.localRange.end = moment(values[1]._d).format("YYYY-MM-DD");
      this.emitChange();
    },
    emitChange() {
      this.$emit("change", this.filterPayload);
    },
  },
};
</script>

<style scoped lang="scss">
.w-100 {
  width: 100%;
}

.number {
  font-weight: 500;
  margin-bottom: 0;
  margin-top: 20px;
}

.v-date-range .v-menu--inline {
  display: inline;
}

.charts div,
.charts .echarts canvas {
  max-width: 100%;
}
</style>
